export const environment = {
    production: true,
    version: "v6.1.9",
    firebaseConfig: {
      apiKey: "AIzaSyCOQ1KgmgpOTG0SSh82BBDcDdIFMyZFbPM",
      authDomain: "lineleap-dev.firebaseapp.com",
      projectId: "lineleap-dev",
      storageBucket: "lineleap-dev.appspot.com",
      messagingSenderId: "139691558685"
    },
    googleConfig: {
      apiKey: "AIzaSyDm4ZmSplQOgm3dGnkuP5S913i6tIdKQnI"
    },
    apiBaseUrl: "https://api-legacy.ll-dev.com",
    orders: "prodOrders",
    cities: "prodCities",
    users: "prodUsers",
    products: "prodProducts",
    venues: "prodVenues",
    recipients: "prodEmailRecipients",
    ticketing: "prodEvents",
    events: "Events",
    drinks: "prodDrinks",
    categories: "prodCategories",
    stream: "admin_event_stream",
    createAdminUrl:
      "https://us-central1-lineleap-dev.cloudfunctions.net/prodCreateAdmin?",
    ticketingDashboardBaseURL: "https://dashboard.ll-dev.com",
    redirectToDashboardPermission: "EN_1563_REDIRECT_TO_DASHBOARD",
    showDashboardBannerPermission: "EN_1563_SHOW_DASHBOARD_BANNER",
    moveTicketingPermission: "WEB_717_MOVE_TICKETING",
    moveEventReorderingPermission: "WEB_767_MOVE_EVENT_REORDERING",
    moveAdminUserManagement: "WEB_800_MOVE_ADMIN_USERS",
    moveEmailRecipientManagement: "WEB_801_MOVE_EMAIL_RECIPIENTS",
    moveVenueAnalyticsTab: "WEB_769_MOVE_ANALYTICS_TAB",
    movePassesTab: "WEB_769_MOVE_PASSES_TAB",
    moveCalendarTab: "WEB_769_MOVE_CALENDAR_TAB",
    moveVenueOrdersTab: "WEB_769_MOVE_VENUE_ORDERS_TAB",
    moveMarketingTab: "WEB_769_MOVE_MARKETING_TAB",
    moveVenueInfoTab: "WEB_769_MOVE_VENUE_INFO_TAB",
    moveCityCreation: "WEB_770_MOVE_CITY_CREATION",
    moveVenueCreation: "WEB_816_MOVE_VENUE_CREATION",
    moveAnalytics: "WEB_803_MOVE_ANALYTICS"
  };
